export const cardsauxReducer = (state = { loading:true, result:null, cardsaux:[], cardsparent:[], cardaux:null, cardsdenied:false, cardsaccept:false } , action) => {
    switch (action.type) {
        case 'CARDAUX_ADD_SUCCESS':
            return {
                ...state,
                loading:false
            }
        case 'CARDSAUX_GET_SUCCESS':
            return {
                ...state,
                loading:false,
                cardsaux: action.payload
            }
        case 'CARDAUX_GET_DETAIL_SUCCESS':
            return {
                ...state,
                loading:false,
                cardaux: action.payload
            }
        case 'CARDAUX_GET_BY_OPERATOR_SUCCESS':
            return {
                ...state,
                loading:false,
                cardsaux: action.payload
            }
        case 'CARDAUX_GET_FOR_OPERATOR_SUCCESS':
            return {
                ...state,
                loading:false,
                cardsaux: action.payload.cardsaux,
                cardsparent: action.payload.cardsparent
            }
        case 'CARDAUX_DELETE_SUCCESS':
            return {...state,
                loading:false,
                result: action.payload.message,
                cardsaux: state.cardsaux.filter(cardaux => cardaux._id !== action.payload.idCardaux)
            }
        case 'CARDAUX_DENI_SUCCESS':
            return {...state,
                loading:false,
                result: action.payload.message,
                cardsaux: state.cardsaux.filter(cardaux => cardaux._id !== action.payload.idCardaux),
                cardsdenied: true
            }
        case 'CARDAUX_DENI_RESET':
            return {...state,
                cardsdenied: false
            }
        case 'CARDAUX_ACCEPT_SUCCESS':
            return {...state,
                loading:false,
                result: action.payload.message,
                cardsaux: state.cardsaux.filter(cardaux => cardaux._id !== action.payload.idCardaux),
                cardsaccept: true
            }
        case 'CARDAUX_ACCEPT_RESET':
            return {...state,
                cardsaccept: false
            }
        case 'CARDAUX_DELETE_NOT_SUCCESS':
            return {...state,
                loading: false,
                result: action.payload
            }
        case 'CARDAUX_RESET_RESULT':
            return {...state,
                result: null
            }
        case 'CARDAUX_LOADING':
            return {
                ...state,
                loading:true
            }
        case 'CARDAUX_ERROR':
            return {
                ...state,
                loading:false
            }
        default:
            return state
    }
}

